wbApp.controller('FranchisesEmployeesDetailCtrl', ['$scope', '$modal', 'franchiseSvc', 'tenantInfo',
function ($scope, $modal, franchiseSvc, tenantInfo) {
    $scope.modelOrig = angular.copy($scope.model);

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.gridOptions = {
        sortInfo: { fields: ['franchiseSubjectName'], directions: ['dsc'] },
        columnDefs: [
            { field: 'franchiseSubjectName', displayName: "TXT_LBL_SUBJECT", sort: 'locale' },
            { field: 'validFrom', displayName: "TXT_LAB_VALID_FROM", cellFilter: 'date:shortDate', width: '100px' },
            { field: 'validTo', displayName: "TXT_LAB_VALID_TO", cellFilter: 'date:shortDate', width: '100px' }
    ]
    };

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.licenses = $scope.model.licenses;
            detailDialogPromise.$scope.modelOrig = { isNew: true };
            detailDialogPromise.show();
        });
    }

    $scope.onRowEdit = function (license) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.licenses = $scope.model.licenses;
            detailDialogPromise.$scope.modelOrig = license;
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (license) {
        _.pull($scope.model.licenses, license);
    }

    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        franchiseSvc.updateEmployeeByTenant($scope.selectedFranchise.franchiseTenantAlias, data, success, error);

        function success(newData) {
            $scope.$hide();
            $scope.onSaveSuccess(newData);
        }

        function error(errorResult) {
            $scope.detailError = errorResult;
            $scope.isSaving = false;
        }
    }

    var detailDialogPromise = $modal({
        templateUrl: 'franchise/franchises-tabs/employee-license-detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);